import TDDashboardTabs from '../../../../components/TDDashboardTabs/TDDashboardTabs';
import PageWithHeader from '../../../../layouts/pageWithHeader/PageWithHeader';
import TableDashboard from '../../../../view/tableDashboard/TableDashboard';
import useLicenses from './useLicenses';

const Licenses = () => {
  const {
    total,
    offset,
    columns,
    licenses,
    onClickOnLicense,
    pageSize,
    isLoading
  } = useLicenses();

  return (
    <PageWithHeader
      left={
        <TDDashboardTabs
          tabs={[
            { name: 'Licenses', to: '/licenses', key: 'licenses' },
            {
              name: 'Batch Licenses',
              to: '/licenses-batch',
              key: 'batchLicenses'
            }
          ]}
          currentTab={'licenses'}
        />
      }
    >
      <TableDashboard
        disableFiltersAndSearch
        filters={[
          {
            id: 'status',
            key: 'status',
            title: 'Status',
            type: 'radio',
            options: [
              { label: 'Active', value: 'active' },
              { label: 'Inactive', value: 'inactive' }
            ]
          }
        ]}
        onSearch={() => {}}
        onFilter={() => {}}
        tableData={licenses}
        // onRowClick={onClickOnLicense}
        tableColumns={columns}
        totalEntries={total}
        // onClickOnCreate={() => {}}
        singleEntryLabel='license'
        pluralEntryLabel='licenses'
        searchInputPlaceholder='Search licenses'
        numberOfFilters={0}
        isTableDataLoading={isLoading}
      />
    </PageWithHeader>
  );
};

export default Licenses;
